import clsx from 'clsx';
import toSafeInteger from 'lodash/toSafeInteger';
import { FC } from 'react';
import React from 'react';
import { Nbsp } from '../../../../base-components/Nbsp';
import styles from './FacetBadgeLabel.module.scss';

interface Props {
    value: number;
    hideZero?: boolean;
    dark?: boolean;
    className?: string;
}

export const FacetBadgeLabel: FC<Props> = ({
    value,
    hideZero,
    dark,
    className,
    children,
}) => {
    const intValue = toSafeInteger(value);
    const showMatches = intValue || !hideZero;
    return (
        <>
            <span>{children}</span>
            <Nbsp />
            {showMatches && (
                <span
                    className={clsx(
                        styles.badge,
                        dark && styles.dark,
                        className
                    )}
                >
                    {intValue}
                </span>
            )}
        </>
    );
};
